import {
  Box,
  SimpleGrid,
  Text,
  Link,
  useColorModeValue as mode,
} from "@chakra-ui/react";

import { useUserSubscriptionValue } from "#app/hooks/index.js";

import {
  BasicPricingCard,
  FlexiblePricingCard,
  ProPricingCard,
  TrialPricingCard,
  UnlimitedPricingCard,
} from "./PricingCards/index.jsx";

export const Pricing = ({ hasTrial = true }) => {
  const LegacyPricingCard = useUserSubscriptionValue({
    none: () => null,
    trial: () => null,
    active_unlimited: () => <UnlimitedPricingCard badgeText="your plan" />,
    active_flexible: () => <FlexiblePricingCard badgeText="your plan" />,
    active_basic: () => null,
    active_pro: () => null,
  });

  return (
    <>
      <SimpleGrid
        alignItems="flex-start"
        columns={{
          base: 1,
          lg: hasTrial || LegacyPricingCard ? 3 : 2,
        }}
        spacing={hasTrial || LegacyPricingCard ? 5 : 10}
      >
        {hasTrial ? <TrialPricingCard /> : LegacyPricingCard}
        <ProPricingCard borderColor="brand.400" borderWidth="2px" />
        <BasicPricingCard />
      </SimpleGrid>
    </>
  );
};

export function TellMeMore({ ...props } = {}) {
  return (
    <Box
      bg={mode("white", "gray.800")}
      shadow="md"
      rounded="lg"
      p="8"
      mx="auto"
      maxW={{
        base: "lg",
        lg: "unset",
      }}
      {...props}
    >
      <Text
        color="accent"
        textTransform="uppercase"
        fontWeight="bold"
        letterSpacing="wide"
        mb={2}
      >
        Tell me more
      </Text>
      <Text fontSize="xl" fontWeight="bold" mb={4}>
        Can't afford to upgrade?
      </Text>
      <Box>
        <Text>
          We believe camping should be accessible to all. If you're struggling
          financially, please email your situation to{" "}
          <Link
            isExternal
            href="mailto:help@schnerp.com?subject=Schnerp%20Alternate%20Payment%20Options"
          >
            help@schnerp.com
          </Link>
          , and we'll try to help you out.
        </Text>
      </Box>
    </Box>
  );
}
